import { Component } from "@angular/core";
import { DataServiceService } from "../data-service.service";

@Component({
  selector: "app-partner-search-test",
  templateUrl: "./partner-search-test.component.html",
  styleUrls: ["./partner-search-test.component.scss"],
})
export class PartnerSearchTestComponent {
  keyword = "";
  isEntity = false;
  isChineseSearch = false;

  isLoading = false;
  token = localStorage.getItem("token") || "";

  result: any = null;
  error: any = null;

  constructor(private dataService: DataServiceService) {}

  async search() {
    this.error = null;
    this.result = null;
    this.isLoading = true;

    try {
      if (!this.token) {
        throw new Error("Missing partner token: localStorage.token is empty");
      }

      this.result = await this.dataService.partnerQuickSearch({
        name: this.keyword,
        isEntity: this.isEntity,
        isChineseSearch: this.isChineseSearch,
      });
    } catch (e) {
      this.error = e;
    } finally {
      this.isLoading = false;
      this.token = localStorage.getItem("token") || "";
    }
  }

  clear() {
    this.keyword = "";
    this.result = null;
    this.error = null;
  }

  clearSavedToken() {
    localStorage.removeItem("token");
    this.token = "";
  }
}

